/**
 * Dealer profile inventory card analytics (Dealer Profile M10).
 */
import { trackBuyerEvent } from "../buyerAnalytics";
import { sanitizeAnalyticsPayload } from "../../analytics/sanitize";
import { DEALER_PROFILE_ANALYTICS_EVENTS } from "../../constants/dealerProfileAnalyticsConstants";
import { DEALER_PROFILE_SOURCE_PAGE } from "../../constants/dealerProfileContactConstants";
import { buildDealerAnalyticsPayload } from "./dealerProfileViewModels";
import { toListingAnalyticsPayload } from "../automapListing/listingViewModels";

export function buildDealerInventoryCardAnalyticsPayload(dealer, listing, extra = {}) {
  const listingPayload = toListingAnalyticsPayload(listing, {
    sourcePage: extra.sourcePage || DEALER_PROFILE_SOURCE_PAGE,
    sourceComponent: extra.sourceComponent || "dealer_inventory_card",
    ...extra,
  });

  return sanitizeAnalyticsPayload({
    ...buildDealerAnalyticsPayload(dealer, {
      sourcePage: extra.sourcePage || DEALER_PROFILE_SOURCE_PAGE,
      sourceComponent: extra.sourceComponent || "dealer_inventory_card",
    }),
    listingId: listingPayload.listingId,
    listingSlug: listing?.slug || listing?.id || null,
    position: extra.position ?? null,
    make: listingPayload.make,
    model: listingPayload.model,
    year: listingPayload.year,
    priceCop: listingPayload.priceCop,
    fairPriceLabel: listingPayload.fairPriceLabel,
    riskLevel: listingPayload.riskLevel,
    city: listingPayload.city,
    sourceAction: extra.sourceAction || null,
  });
}

export function trackDealerInventoryCardClick(dealer, listing, extra = {}) {
  trackBuyerEvent(
    DEALER_PROFILE_ANALYTICS_EVENTS.INVENTORY_CARD_CLICKED,
    buildDealerInventoryCardAnalyticsPayload(dealer, listing, extra)
  );
}
